export default {
  namespaced: true,
  state: {
    currentTab: 'spot', // price: spot/futures
  },
  mutations: {
    SET_CURRENT_TAB(state, tab) {
      state.currentTab = tab;
    },
  },
  actions: {
  }
};